<!-- Hygiene Cleaning - same UI as Report, with Block, Floor, Room -->
<div class="hr-layout">
  <!-- <app-hygine-sidebar></app-hygine-sidebar> -->
  <div class="hr-main-content">
    <div class="hr-report-panel">
      <div class="hr-page-outer">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="hr-page-wrap">
                <div class="hr-header-row">
                  <div class="hr-header-top">
                    <h1 class="hr-main-title">Hygiene Activity</h1>
                    <div class="hr-segment-groups" role="group" aria-label="Filters">
                      <div class="hr-segment-pair" aria-label="School or College">
                        <button type="button" class="hr-segment-btn"
                          [class.hr-segment-active]="schoolOrCollege === 'COLLEGE'"
                          (click)="selectSchoolOrCollege('COLLEGE')">College</button>
                        <button type="button" class="hr-segment-btn"
                          [class.hr-segment-active]="schoolOrCollege === 'SCHOOL'"
                          (click)="selectSchoolOrCollege('SCHOOL')">School</button>
                      </div>
                      <span class="hr-segment-divider" aria-hidden="true"></span>
                      <div class="hr-segment-pair" aria-label="Residential or Day scholar">
                        <button type="button" class="hr-segment-btn"
                          [class.hr-segment-active]="boardingSegment === 'RESIDENTIAL'"
                          (click)="selectBoarding('RESIDENTIAL')">Residential</button>
                        <button type="button" class="hr-segment-btn"
                          [class.hr-segment-active]="boardingSegment === 'DAY_SCHOLAR'"
                          (click)="selectBoarding('DAY_SCHOLAR')">Day scholar</button>
                      </div>
                    </div>
                  </div>
                  <div class="hr-filter-bar-wrapper">
                    <div class="hr-combobox">
                      <div class="hr-combobox-trigger" (click)="openState()" [class.hr-trigger-open]="stateOpen">
                        <span class="hr-trigger-text">{{ stateTriggerText }}</span>
                        <span class="hr-trigger-chevron"><i class="fa fa-chevron-down"></i></span>
                      </div>
                      <div class="hr-combobox-panel" *ngIf="stateOpen">
                        <div class="att-search-container">
                          <input type="text" class="form-control att-search-input" placeholder="Search State"
                            [(ngModel)]="stateQuery" (keyup)="filterStates()" (mousedown)="$event.stopPropagation()">
                        </div>
                        <div class="list_campus">
                          <ng-container *ngFor="let s of filteredStateList">
                            <ul class="att-dropdown-item" (mousedown)="selectState(s); $event.preventDefault()"
                              [class.att-item-selected]="selectedStateId === (s.stateId ?? s.id)">
                              <li class="att-item-text">{{ s.stateName ?? s.name ?? s }}</li>
                              <li><i *ngIf="selectedStateId === (s.stateId ?? s.id)"
                                  class="fa fa-check att-check-icon"></i></li>
                            </ul>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                    <span class="hr-filter-sep"></span>
                    <div class="hr-combobox">
                      <div class="hr-combobox-trigger" (click)="openCity()" [class.hr-trigger-open]="cityOpen">
                        <span class="hr-trigger-text">{{ selectedCityName || 'Select City' }}</span>
                        <span class="hr-trigger-chevron"><i class="fa fa-chevron-down"></i></span>
                      </div>
                      <div class="hr-combobox-panel" *ngIf="cityOpen">
                        <div class="att-search-container">
                          <input type="text" class="form-control att-search-input" placeholder="Search City"
                            [(ngModel)]="cityQuery" (keyup)="filterCities()" (mousedown)="$event.stopPropagation()">
                        </div>
                        <div class="list_campus">
                          <ng-container *ngFor="let c of filteredCityList">
                            <ul class="att-dropdown-item" (mousedown)="selectCity(c); $event.preventDefault()"
                              [class.att-item-selected]="selectedCityId === (c.cityId ?? c.id)">
                              <li class="att-item-text">{{ c.cityName ?? c.name ?? c }}</li>
                              <li><i *ngIf="selectedCityId === (c.cityId ?? c.id)"
                                  class="fa fa-check att-check-icon"></i></li>
                            </ul>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                    <span class="hr-filter-sep"></span>
                    <div class="hr-combobox">
                      <div class="hr-combobox-trigger" (click)="openCampus()" [class.hr-trigger-open]="campusOpen">
                        <span class="hr-trigger-text">{{ selectedCampusName || 'Select Campus' }}</span>
                        <span class="hr-trigger-chevron"><i class="fa fa-chevron-down"></i></span>
                      </div>
                      <div class="hr-combobox-panel" *ngIf="campusOpen">
                        <div class="att-search-container">
                          <input type="text" class="form-control att-search-input" placeholder="Search Campus"
                            [(ngModel)]="campusQuery" (keyup)="filterCampuses()" (mousedown)="$event.stopPropagation()">
                        </div>
                        <div class="list_campus">
                          <ng-container *ngFor="let c of filteredCampusList">
                            <ul class="att-dropdown-item" (mousedown)="selectCampus(c); $event.preventDefault()"
                              [class.att-item-selected]="selectedCampusId === (c.campusId ?? c.id)">
                              <li class="att-item-text">{{ c.campusName ?? c.name ?? c }}</li>
                              <li><i *ngIf="selectedCampusId === (c.campusId ?? c.id)"
                                  class="fa fa-check att-check-icon"></i></li>
                            </ul>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                    <span class="hr-filter-sep"></span>
                    <div class="hr-combobox">
                      <div class="hr-combobox-trigger" (click)="openBuilding()" [class.hr-trigger-open]="buildingOpen">
                        <span class="hr-trigger-text">{{ selectedBuildingName || 'Select Building' }}</span>
                        <span class="hr-trigger-chevron"><i class="fa fa-chevron-down"></i></span>
                      </div>
                      <div class="hr-combobox-panel" *ngIf="buildingOpen">
                        <div class="att-search-container">
                          <input type="text" class="form-control att-search-input" placeholder="Search Building"
                            [(ngModel)]="buildingQuery" (keyup)="filterBuildings()"
                            (mousedown)="$event.stopPropagation()">
                        </div>
                        <div class="list_campus">
                          <ng-container *ngFor="let b of filteredBuildingList">
                            <ul class="att-dropdown-item" (mousedown)="selectBuilding(b); $event.preventDefault()"
                              [class.att-item-selected]="selectedBuildingId === (b.buildingId ?? b.id)">
                              <li class="att-item-text">{{ b.buildingName ?? b.name ?? b }}</li>
                              <li><i *ngIf="selectedBuildingId === (b.buildingId ?? b.id)"
                                  class="fa fa-check att-check-icon"></i></li>
                            </ul>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                    <span class="hr-filter-sep"></span>
                    <div class="hr-combobox">
                      <div class="hr-combobox-trigger" (click)="openBlock()" [class.hr-trigger-open]="blockOpen">
                        <span class="hr-trigger-text">{{ selectedBlockName || 'Select Block' }}</span>
                        <span class="hr-trigger-chevron"><i class="fa fa-chevron-down"></i></span>
                      </div>
                      <div class="hr-combobox-panel" *ngIf="blockOpen">
                        <div class="list_campus">
                          <ng-container *ngFor="let b of blockList">
                            <ul class="att-dropdown-item" (mousedown)="selectBlock(b); $event.preventDefault()"
                              [class.att-item-selected]="selectedBlockId === b.id">
                              <li class="att-item-text">{{ b.name }}</li>
                              <li><i *ngIf="selectedBlockId === b.id" class="fa fa-check att-check-icon"></i></li>
                            </ul>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                    <div class="hr-filter-bar-spacer"></div>
                    <button type="button" class="hr-search-btn" (click)="onSearch()">
                      <i class="fa fa-search"></i> Search
                    </button>
                  </div>
                </div>

                <!-- Summary cards -->
                <div class="row hr-cards-row">
                  <div class="col-6 col-md-3">
                    <div class="hr-summary-card hr-card-purple" [class.hr-card-active]="activeDateTab === 'today'"
                      (click)="selectDateTab('today')" role="button" tabindex="0">
                      <i class="fa fa-camera hr-summary-icon"></i>
                      <div class="hr-summary-text">
                        <span class="hr-summary-label">Today's Photo</span>
                        <span class="hr-summary-value">{{ reportData?.todayPhotoCount ?? 0 }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-6 col-md-3">
                    <div class="hr-summary-card hr-card-orange" [class.hr-card-active]="activeDateTab === 'yesterday'"
                      (click)="selectDateTab('yesterday')" role="button" tabindex="0">
                      <i class="fa fa-calendar-minus hr-summary-icon"></i>
                      <div class="hr-summary-text">
                        <span class="hr-summary-label">Yesterday's Photo</span>
                        <span class="hr-summary-value">{{ reportData?.yesterdayPhotoCount ?? 0 }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-6 col-md-3">
                    <div class="hr-summary-card hr-card-green" [class.hr-card-active]="activeDateTab === 'last7'"
                      (click)="selectDateTab('last7')" role="button" tabindex="0">
                      <i class="fa fa-calendar-week hr-summary-icon"></i>
                      <div class="hr-summary-text">
                        <span class="hr-summary-label">Last 7 day's</span>
                        <span class="hr-summary-value">{{ reportData?.last7DaysPhotoCount ?? 0 }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-6 col-md-3">
                    <div class="hr-summary-card hr-card-red" [class.hr-card-active]="activeDateTab === 'month'"
                      (click)="selectDateTab('month')" role="button" tabindex="0">
                      <i class="fa fa-calendar-alt hr-summary-icon"></i>
                      <div class="hr-summary-text">
                        <span class="hr-summary-label">This Month</span>
                        <span class="hr-summary-value">{{ reportData?.thisMonthPhotoCount ?? 0 }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="hr-main-card">
                  <div class="hr-tabs-row">
                    <div class="hr-date-tabs">
                      <button type="button" class="hr-tab" [class.hr-tab-active]="activeDateTab === 'today'"
                        (click)="selectDateTab('today')">Today</button>
                      <button type="button" class="hr-tab" [class.hr-tab-active]="activeDateTab === 'yesterday'"
                        (click)="selectDateTab('yesterday')">Yesterday</button>
                      <button type="button" class="hr-tab" [class.hr-tab-active]="activeDateTab === 'last7'"
                        (click)="selectDateTab('last7')">Last 7 days</button>
                      <button type="button" class="hr-tab" [class.hr-tab-active]="activeDateTab === 'month'"
                        (click)="selectDateTab('month')">This Month</button>
                      <button type="button" class="hr-tab" [class.hr-tab-active]="activeDateTab === 'custom'"
                        (click)="selectDateTab('custom')">Custom Date</button>
                    </div>
                    <!-- <button type="button" class="hr-compare-btn">Compare</button> -->
                  </div>

                  <div class="hr-custom-date-wrap" *ngIf="activeDateTab === 'custom'">
                    <div class="hr-date-range-input-wrap">
                      <input #dateRangeInput type="text" class="hr-date-range-input" placeholder="Select Date Range"
                        readonly>
                      <i class="fa fa-calendar hr-date-range-icon"></i>
                    </div>
                    <span class="hr-date-range-hint">Select start date and end date</span>
                  </div>

                  <!-- No data: show Search placeholder -->
                  <div *ngIf="!activityReportData" class="hc-no-building-wrap">
                    <h2 class="hr-content-heading hc-todays-pictures-heading">
                      {{ getDateTabPicturesLabel() }} ({{ getDateTabPicturesCount() }})
                    </h2>
                    <div class="hr-pictures-grid">
                      <div class="hr-pic-card hr-pic-card-placeholder" (click)="onSearch()" role="button" tabindex="0">
                        <div class="hr-pic-placeholder">
                          <i class="fa fa-search"></i>
                        </div>
                        <div class="hr-pic-info">
                          <span class="hr-pic-dept">Search</span>
                          <span class="hr-pic-meta">Select filters and click Search to load activity photos</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- When API has data: activity cards; floor/room only when building selected -->
                  <ng-container *ngIf="activityReportData">
                    <!-- Floor tabs + Room chips: only when API returns isBuilding true -->
                    <div class="hc-floor-row" *ngIf="activityReportData?.isBuilding">
                      <button type="button" class="hc-floor-tab" [class.hc-floor-active]="selectedFloor === null"
                        (click)="selectAllFloors()">All Floors</button>
                      <button type="button" class="hc-floor-tab" *ngFor="let f of floors"
                        [class.hc-floor-active]="selectedFloor === f" (click)="selectFloor(f)">
                        {{ f }}{{ getFloorOrdinal(f) }}Floor
                      </button>
                      <p *ngIf="floors.length === 0" class="hr-no-pictures">No floor data for selected date range.</p>
                    </div>
                    <div class="hc-room-row"
                      *ngIf="activityReportData?.isBuilding && floors.length > 0 && selectedFloor != null">
                      <button type="button" class="hc-room-chip" *ngFor="let r of rooms"
                        [class.hc-room-active]="selectedRoom === r" (click)="selectRoom(r)">{{ r }}</button>
                      <p *ngIf="rooms.length === 0 && selectedFloor != null" class="hr-no-pictures">No rooms on this
                        floor.</p>
                    </div>

                    <!-- Picture count + filter context (only when isBuilding) -->
                    <div class="hr-content-heading-row">
                      <h2 class="hr-content-heading">
                        <span class="hr-content-count">{{ totalPictures }} Pictures found</span>
                        <span class="hc-filter-label"
                          *ngIf="activityReportData?.isBuilding && selectedFloor != null && selectedRoom"> · {{
                          selectedFloor }}{{ getFloorOrdinal(selectedFloor) }}floor : Room no. {{ selectedRoom }}</span>
                        <span class="hc-filter-label" *ngIf="activityReportData?.isBuilding && selectedFloor === null">
                          · All floors & rooms</span>
                      </h2>
                    </div>

                    <div class="hr-pictures-grid">
                      <div class="hr-pic-card" *ngFor="let p of paginatedPictures" (click)="openImageDialog(p)">
                        <div class="hr-pic-placeholder" (click)="$event.stopPropagation(); openImageDialog(p)">
                          <img *ngIf="p.imageUrl" [src]="p.imageUrl" [alt]="p.activityName" class="hr-pic-img"
                            (error)="onImageError(p.hygieneId)" draggable="false">
                          <i *ngIf="!p.imageUrl || imageErrorIds.has(p.hygieneId)" class="fa fa-image"></i>
                        </div>
                        <div *ngIf="p.campusName || p.buildingName || selectedCampusName" class="hr-pic-campus-below">
                          <span class="hr-pic-campus-text">{{ ((p.campusName || selectedCampusName || '') +
                            ((p.campusName || selectedCampusName) && p.buildingName ? ' · ' : '') + (p.buildingName ||
                            '')) | uppercase }}</span>
                          <span *ngIf="p.latitude != null && p.longitude != null" class="hr-pic-map-icon-wrap"
                            (mousedown)="onMapIconClick($event, p.latitude, p.longitude)"
                            (click)="$event.stopPropagation(); $event.preventDefault()" role="button" tabindex="0"
                            (keydown.enter)="onMapIconClick($event, p.latitude, p.longitude)">
                            <img [src]="mapIconPath" alt="Map" class="hr-pic-location-icon hr-pic-location-clickable">
                          </span>
                        </div>
                        <div class="hr-pic-employee-below" *ngIf="p.employeeName || p.designation || p.mobileNo">
                          <div *ngIf="p.employeeName" class="hr-pic-image-taken-by-row">
                            <span class="hr-pic-image-taken-by-label">Image taken by</span>
                            <span class="hr-pic-employee-line">{{ p.employeeName }}</span>
                          </div>
                          <span *ngIf="p.designation" class="hr-pic-employee-line">{{ p.designation }}</span>
                          <span *ngIf="p.mobileNo" class="hr-pic-employee-line">{{ p.mobileNo }}</span>
                        </div>
                        <div class="hr-pic-info">
                          <span class="hr-pic-dept">{{ p.activityName || 'Activity' }}</span>
                          <span class="hr-pic-meta">
                            <span class="hr-pic-datetime" *ngIf="getCleaningCardDateTime(p)">{{
                              getCleaningCardDateTime(p) }}</span>
                            <span *ngIf="p.slot" class="hr-pic-slot">{{ p.slot }}</span>
                            <span *ngIf="!p.capturedTime && !p.slot">{{ getFloorRoomLine(p.floorName, p.roomDisplayName)
                              }}</span>
                          </span>
                        </div>
                      </div>
                      <p *ngIf="activityReportData && totalPictures === 0" class="hr-no-pictures">No pictures found.</p>
                    </div>

                    <div class="hr-pagination" *ngIf="totalPictures > 0">
                      <button type="button" class="hr-page-btn" [disabled]="currentPage <= 1"
                        (click)="setPage(currentPage - 1)">Previous</button>
                      <button type="button" class="hr-page-btn hr-page-skip" [disabled]="currentPage <= 1"
                        (click)="goBack10()">Back 10</button>
                      <ng-container *ngFor="let slot of paginationSlots">
                        <span *ngIf="slot === 'ellipsis'" class="hr-page-ellipsis">…</span>
                        <button *ngIf="slot !== 'ellipsis'" type="button" class="hr-page-num"
                          [class.hr-page-active]="currentPage === slot" (click)="setPage(slot)">{{ slot }}</button>
                      </ng-container>
                      <button type="button" class="hr-page-btn hr-page-skip" [disabled]="currentPage >= totalPages"
                        (click)="goForward10()">Forward 10</button>
                      <button type="button" class="hr-page-btn" [disabled]="currentPage >= totalPages"
                        (click)="setPage(currentPage + 1)">Next</button>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ngx-spinner class="spinner" bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>